<template>
  <span style="display: inline-block; height: 100%">
    My credits: <strong>{{ creditsAmount }}</strong>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRootStore } from '@/stores/useRootStore'

const rootStore = useRootStore()

const creditsAmount = computed(() => {
  if (!rootStore.user) return 'N/A'
  return rootStore.getCreditsAmount
})
</script>
